/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import { Box, Typography } from "@mui/material";

function Error404Page() {
  return (
    <MKBox component="section" py={4}> {/* Reduced padding */}
      <Container>
        <Grid container spacing={3} alignItems="center" justifyContent="center">
          <Grid item xs={12} lg={12}>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              textAlign="center"
            >
              <img src="/img/Error message image.jpg" alt="404 Not Found" width="300" />
              <Typography variant="h4" mt={1}> {/* Reduced margin-top */}
                Sorry for the inconvenience.<br />
                The resource you are looking for is not currently available.<br />
                Please <a href="/contact-us"><u>contact</u></a> us if you need assistance.
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Error404Page;
